import { lazy, Suspense, useState } from 'react'
import { useModals } from '../contexts/ModalContext.jsx'
import { Header } from './Header.jsx'
import { Footer } from './Footer.jsx'
import { FounderModal } from './FounderModal.jsx'

// The quiz modal (and the catalog it fetches) is only downloaded once someone
// opens it, instead of on every page load. Kept mounted afterwards so closing
// and reopening resumes where the visitor left off.
const BarryModal = lazy(() => import('./BarryModal.jsx').then((m) => ({ default: m.BarryModal })))

function LazyBarryModal() {
  const { barryOpen } = useModals()
  const [opened, setOpened] = useState(barryOpen)
  if (barryOpen && !opened) setOpened(true)
  if (!opened) return null
  return (
    <Suspense fallback={null}>
      <BarryModal />
    </Suspense>
  )
}

export function PageLayout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>{children}</main>
      <Footer />
      <LazyBarryModal />
      <FounderModal />
    </div>
  )
}
